import { render, staticRenderFns } from "./Trainers.vue?vue&type=template&id=4155f56f&scoped=true&"
import script from "./Trainers.vue?vue&type=script&lang=js&"
export * from "./Trainers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4155f56f",
  null
  
)

export default component.exports